import { createContext } from 'react';

import { MapContextProps } from './types';

export const MapContext = createContext({} as MapContextProps);
